// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Lazy from "../Control.Lazy/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_LogicExpr_AST from "../Data.LogicExpr.AST/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var foldMapWithIndex = /* #__PURE__ */ Data_FoldableWithIndex.foldMapWithIndex(Data_Map_Internal.foldableWithIndexMap)(Data_Monoid.monoidArray);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "boolean";
    }
});
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "term";
    }
});
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var foldlWithIndex = /* #__PURE__ */ Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap);
var fix = /* #__PURE__ */ Control_Lazy.fix(Control_Lazy.lazyFn);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_List_Types.applicativeList);
var foldr = /* #__PURE__ */ Data_Foldable.foldr(Data_List_Types.foldableList);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_List_Types.semigroupList);
var DNF = function (x) {
    return x;
};
var CNF = function (x) {
    return x;
};
var nfTo2D = function (dictFoldable) {
    var fromFoldable = Data_Array.fromFoldable(dictFoldable);
    return function (xs) {
        var f = function (term) {
            return function ($$boolean) {
                return [ {
                    term: term,
                    "boolean": $$boolean
                } ];
            };
        };
        return map(foldMapWithIndex(f))(fromFoldable(xs));
    };
};
var showNF = function (dictFoldable) {
    var nfTo2D1 = nfTo2D(dictFoldable);
    return function (dictShow) {
        var show = Data_Show.show(Data_Show.showArray(Data_Show.showArray(showRecord(showRecordFieldsCons(showRecordFieldsConsNil(dictShow))(Data_Show.showBoolean)))));
        return function (xs) {
            return show(nfTo2D1(xs));
        };
    };
};
var newtypeDNF = {
    Coercible0: function () {
        return undefined;
    }
};
var showDNF = function (dictFoldable) {
    var showNF1 = showNF(dictFoldable);
    return function (dictShow) {
        return {
            show: (function () {
                var $129 = showNF1(dictShow);
                return function ($130) {
                    return $129(unwrap($130));
                };
            })()
        };
    };
};
var newtypeCNF = {
    Coercible0: function () {
        return undefined;
    }
};
var showCNF = function (dictFoldable) {
    var showNF1 = showNF(dictFoldable);
    return function (dictShow) {
        return {
            show: (function () {
                var $131 = showNF1(dictShow);
                return function ($132) {
                    return $131(unwrap($132));
                };
            })()
        };
    };
};
var mergeNFClause = function (dictOrd) {
    var lookup = Data_Map_Internal.lookup(dictOrd);
    var insert = Data_Map_Internal.insert(dictOrd);
    return function (a) {
        return function (b) {
            var f = function (v) {
                return function (v1) {
                    return function (v2) {
                        if (v1 instanceof Data_Maybe.Nothing) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (v1 instanceof Data_Maybe.Just) {
                            var v3 = lookup(v)(v1.value0);
                            if (v3 instanceof Data_Maybe.Just) {
                                if (v3.value0 === v2) {
                                    return new Data_Maybe.Just(v1.value0);
                                };
                                if (Data_Boolean.otherwise) {
                                    return Data_Maybe.Nothing.value;
                                };
                            };
                            if (v3 instanceof Data_Maybe.Nothing) {
                                return new Data_Maybe.Just(insert(v)(v2)(v1.value0));
                            };
                            throw new Error("Failed pattern match at Data.LogicExpr.NormalForm (line 70, column 28 - line 73, column 49): " + [ v3.constructor.name ]);
                        };
                        throw new Error("Failed pattern match at Data.LogicExpr.NormalForm (line 69, column 9 - line 69, column 32): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
                    };
                };
            };
            return foldlWithIndex(f)(new Data_Maybe.Just(a))(b);
        };
    };
};
var mergeNFClauses = function (dictMonadPlus) {
    var bind = Control_Bind.bind((dictMonadPlus.Monad0()).Bind1());
    var Alternative1 = dictMonadPlus.Alternative1();
    var empty = Control_Plus.empty(Alternative1.Plus1());
    var pure1 = Control_Applicative.pure(Alternative1.Applicative0());
    return function (dictOrd) {
        var mergeNFClause1 = mergeNFClause(dictOrd);
        return function (xs) {
            return function (ys) {
                return bind(xs)(function (x) {
                    return bind(ys)(function (y) {
                        return Data_Maybe.maybe(empty)(pure1)(mergeNFClause1(x)(y));
                    });
                });
            };
        };
    };
};
var mergeNFClauses1 = /* #__PURE__ */ mergeNFClauses(Data_List_Types.monadPlusList);
var eqNF = function (dictOrd) {
    var eqMap = Data_Map_Internal.eqMap(dictOrd.Eq0())(Data_Eq.eqBoolean);
    return function (dictEq1) {
        var eq1 = Data_Eq.eq1(dictEq1)(eqMap);
        return function (lhs) {
            return function (rhs) {
                return eq1(lhs)(rhs);
            };
        };
    };
};
var eqDNF = function (dictEq1) {
    return function (dictOrd) {
        var eqNF1 = eqNF(dictOrd)(dictEq1);
        return {
            eq: function (a) {
                return function (b) {
                    return eqNF1(unwrap(a))(unwrap(b));
                };
            }
        };
    };
};
var eqCNF = function (dictEq1) {
    return function (dictOrd) {
        var eqNF1 = eqNF(dictOrd)(dictEq1);
        return {
            eq: function (a) {
                return function (b) {
                    return eqNF1(unwrap(a))(unwrap(b));
                };
            }
        };
    };
};
var deMorgen = function (hPos) {
    return function (hNeg) {
        return function (hConj) {
            return function (hDisj) {
                var go = function (v) {
                    return function (v1) {
                        if (v1 instanceof Data_LogicExpr_AST.Leaf) {
                            return hPos(v1.value0);
                        };
                        if (v1 instanceof Data_LogicExpr_AST.And) {
                            return hConj(v(v1.value0))(v(v1.value1));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Or) {
                            return hDisj(v(v1.value0))(v(v1.value1));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Equiv) {
                            return v(new Data_LogicExpr_AST.And(new Data_LogicExpr_AST.Implies(v1.value0, v1.value1), new Data_LogicExpr_AST.Implies(v1.value1, v1.value0)));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Implies) {
                            return v(new Data_LogicExpr_AST.Or(new Data_LogicExpr_AST.Neg(v1.value0), v1.value1));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.Leaf) {
                            return hNeg(v1.value0.value0);
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.Neg) {
                            return v(v1.value0.value0);
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.And) {
                            return v(new Data_LogicExpr_AST.Or(new Data_LogicExpr_AST.Neg(v1.value0.value0), new Data_LogicExpr_AST.Neg(v1.value0.value1)));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.Or) {
                            return v(new Data_LogicExpr_AST.And(new Data_LogicExpr_AST.Neg(v1.value0.value0), new Data_LogicExpr_AST.Neg(v1.value0.value1)));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.Equiv) {
                            return v(new Data_LogicExpr_AST.Neg(new Data_LogicExpr_AST.And(new Data_LogicExpr_AST.Implies(v1.value0.value0, v1.value0.value1), new Data_LogicExpr_AST.Implies(v1.value0.value1, v1.value0.value0))));
                        };
                        if (v1 instanceof Data_LogicExpr_AST.Neg && v1.value0 instanceof Data_LogicExpr_AST.Implies) {
                            return v(new Data_LogicExpr_AST.Neg(new Data_LogicExpr_AST.Or(new Data_LogicExpr_AST.Neg(v1.value0.value0), v1.value0.value1)));
                        };
                        throw new Error("Failed pattern match at Data.LogicExpr.NormalForm (line 83, column 11 - line 83, column 48): " + [ v.constructor.name, v1.constructor.name ]);
                    };
                };
                return fix(go);
            };
        };
    };
};
var consNF = function (dictOrd) {
    var isSubmap = Data_Map_Internal.isSubmap(dictOrd)(Data_Eq.eqBoolean);
    return function (v) {
        return function (v1) {
            if (v1 instanceof Data_List_Types.Nil) {
                return pure(v);
            };
            if (v1 instanceof Data_List_Types.Cons) {
                if (isSubmap(v)(v1.value0)) {
                    return consNF(dictOrd)(v)(v1.value1);
                };
                if (isSubmap(v1.value0)(v)) {
                    return new Data_List_Types.Cons(v1.value0, v1.value1);
                };
                if (Data_Boolean.otherwise) {
                    return new Data_List_Types.Cons(v1.value0, consNF(dictOrd)(v)(v1.value1));
                };
            };
            throw new Error("Failed pattern match at Data.LogicExpr.NormalForm (line 56, column 1 - line 56, column 86): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var toNormalForm = function (dictOrd) {
    var consNF1 = consNF(dictOrd);
    return function (hConj) {
        return function (hDisj) {
            var hPos = function (t) {
                return pure(Data_Map_Internal.singleton(t)(true));
            };
            var hNeg = function (t) {
                return pure(Data_Map_Internal.singleton(t)(false));
            };
            var $133 = foldr(consNF1)(Data_List_Types.Nil.value);
            var $134 = deMorgen(hPos)(hNeg)(hConj)(hDisj);
            return function ($135) {
                return $133($134($135));
            };
        };
    };
};
var toCNF = function (dictOrd) {
    var $136 = toNormalForm(dictOrd)(append)(mergeNFClauses1(dictOrd));
    return function ($137) {
        return CNF($136($137));
    };
};
var toDNF = function (dictOrd) {
    var $138 = toNormalForm(dictOrd)(mergeNFClauses1(dictOrd))(append);
    return function ($139) {
        return DNF($138($139));
    };
};
var absorbNF = function (dictOrd) {
    var consNF1 = consNF(dictOrd);
    return function (v) {
        if (v instanceof Data_List_Types.Nil) {
            return Data_List_Types.Nil.value;
        };
        if (v instanceof Data_List_Types.Cons) {
            return consNF1(v.value0)(absorbNF(dictOrd)(v.value1));
        };
        throw new Error("Failed pattern match at Data.LogicExpr.NormalForm (line 62, column 1 - line 62, column 71): " + [ v.constructor.name ]);
    };
};
export {
    CNF,
    DNF,
    deMorgen,
    toCNF,
    toDNF,
    newtypeDNF,
    newtypeCNF,
    showDNF,
    showCNF,
    eqDNF,
    eqCNF
};
//# sourceMappingURL=index.js.map
